/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResendTeamInvitationRequest
 */
export interface ResendTeamInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof ResendTeamInvitationRequest
     */
    clientCompanyId: string;
}

/**
 * Check if a given object implements the ResendTeamInvitationRequest interface.
 */
export function instanceOfResendTeamInvitationRequest(value: object): value is ResendTeamInvitationRequest {
    if (!('clientCompanyId' in value) || value['clientCompanyId'] === undefined) return false;
    return true;
}

export function ResendTeamInvitationRequestFromJSON(json: any): ResendTeamInvitationRequest {
    return ResendTeamInvitationRequestFromJSONTyped(json, false);
}

export function ResendTeamInvitationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResendTeamInvitationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientCompanyId': json['clientCompanyId'],
    };
}

export function ResendTeamInvitationRequestToJSON(value?: ResendTeamInvitationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientCompanyId': value['clientCompanyId'],
    };
}

